
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/improve-work-life-balance-scheduled-teams-messages",
      function () {
        return require("private-next-pages/article/improve-work-life-balance-scheduled-teams-messages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/improve-work-life-balance-scheduled-teams-messages"])
      });
    }
  